export default __webpack_public_path__ + "static/brochure2-13f5c80137ab838cfda67e7856958110.webp";